import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";
import { instantiate } from "@micosmo/aframe/lib/utils";
import gameState from "./game-state";
import * as ticker from "@micosmo/ticker/aframe-ticker";
import { onLoadedDo } from '@micosmo/aframe/startup';

const TicksPerSecond = 1000; // Expressed in milliseconds
const ManaSegGapWidth = 0.002;
const ManaDelayDuration = 1000;
const ManaOverlayCycles = 16;
const ColorGrey = '#696969';
const ColorGreen = 'green';
const ColorYellow = '#ffff00';

var ManaUnitWidth, ManaInitUnits, ManaMaxUnits, ManaUnitPoints, ManaOverlayWidthAdjust;
var TimeWarpDuration, TimeWarpFactor;

let score = 0;
let manaAvailUnits = 0;
let manaUnits = 0;
const manaSegX = [];

aframe.registerComponent("warp", {
  schema: {
    init: { type: 'number', default: 0 },
    max: { type: 'number', default: 5 },
    points: { type: 'number', default: 5000 },
    width: { type: 'number', default: 0.05 },
    duration: { type: 'number', default: 10 },
    factor: { type: 'number', default: 0.25 }
  },
  init() {
    ManaUnitPoints = this.data.points;
    ManaUnitWidth = this.data.width;
    ManaMaxUnits = this.data.max;
    TimeWarpDuration = this.data.duration; // Expressed in seconds
    TimeWarpFactor = this.data.factor;
    manaUnits = ManaInitUnits = this.data.init;
    ManaOverlayWidthAdjust = ManaUnitWidth / ManaOverlayCycles;

    this.gameStateEl = document.querySelector("[game-state]");
    this.timeWarpButtonEl = this.el.querySelector("#timeWarpButton");
    this.timeWarpButtonTextEl = this.el.querySelector("#timeWarpButtonText");
    this.manabarEl = this.el.querySelector("#manabar");
    this.manabarOverlayEl = this.el.querySelector("#manabarOverlay");
    const manaBorderEl = this.el.querySelector("#manaBorder");
    const manaBackgroundEl = this.el.querySelector("#manaBackground");

    // Construct the manabar with the required number of segments
    const manabarWidth = ManaMaxUnits * ManaUnitWidth + (ManaMaxUnits - 1) * ManaSegGapWidth; // Allow for segment separators
    manaBackgroundEl.setAttribute('width', manabarWidth);
    manaBorderEl.setAttribute('width', manabarWidth + 0.006); // Allow for left and right border width
    for (let i = 0, x = -(manabarWidth / 2); i < ManaMaxUnits; i++, x += ManaUnitWidth + ManaSegGapWidth) {
      manaSegX[i] = x;
      const prefab = `<a-plane id="Seg${i + 1}" position="${x + ManaUnitWidth / 2} 0 0" color="${ColorGrey}" height="0.01" width="${ManaUnitWidth}"></a-plane>`;
      this.manabarEl.appendChild(instantiate(prefab));
    }

    this.warpProcess = ticker.createProcess({
      name: 'TimeSlow',
      onTick: ticker.timer(TimeWarpDuration, this.warpStep.bind(this)),
      onEnd: this.onWarpEnd.bind(this)
    });

    const manaAddStep = () => {
      this.overlayPosition.x += ManaOverlayWidthAdjust / 2;
      this.manabarOverlayEl.setAttribute("position", this.overlayPosition);
      this.manabarOverlayEl.setAttribute("width", this.overlayWidth -= ManaOverlayWidthAdjust);
    };
    this.manaAddProcess = ticker.createProcess({
      name: 'AddMana',
      onTick: ticker.looper(ManaOverlayCycles - 1, ticker.msWaiter(ManaDelayDuration / (ManaOverlayCycles - 1), manaAddStep)),
      onEnd: () => {
        this.manabarOverlayEl.setAttribute('visible', false);
      }
    });

    const manaRemoveStep = () => {
      this.overlayPosition.x -= ManaOverlayWidthAdjust / 2;
      this.manabarOverlayEl.setAttribute("position", this.overlayPosition);
      this.manabarOverlayEl.setAttribute("width", this.overlayWidth -= ManaOverlayWidthAdjust);
    };
    this.manaRemoveProcess = ticker.createProcess({
      name: 'RemoveMana',
      onTick: ticker.looper(ManaOverlayCycles - 1, ticker.msWaiter(ManaDelayDuration / (ManaOverlayCycles - 1), manaRemoveStep)),
      onEnd: () => {
        this.manabarOverlayEl.setAttribute('visible', false);
      }
    });
    onLoadedDo(() => ticker.locateTicker(this.el).assignAsDefaultTo(this.warpProcess, this.manaAddProcess, this.manaRemoveProcess));
  },

  warpStep(tm, dt, remain) {
    const sec = Math.trunc(remain / TicksPerSecond) + 1;
    if (sec !== this.timeWarpCounter)
      this.timeWarpButtonTextEl.setAttribute("text__start", "value", `${sec}`);
    this.timeWarpCounter = sec;
    return 'more';
  },
  onWarpEnd() {
    this.gameStateEl.emit('endTimeWarp');
    this.timeWarpButtonTextEl.setAttribute("text__start", "value", "ACTIVATE");
    this.timeWarpButtonEl.setAttribute('button', 'pressedColor', 'red');
    if (manaUnits <= 0)
      this.timeWarpButtonEl.setAttribute('visible', false);
  },

  addscore: bindEvent({ target: '[game-state]' }, function (evt) {
    score += evt.detail * gameState.multiplier;
    const newAvailUnits = Math.trunc(score / ManaUnitPoints);
    if (manaAvailUnits >= newAvailUnits) {
      return;
    }
    manaAvailUnits = newAvailUnits;
    if (manaUnits >= ManaMaxUnits)
      return;
    if (this.curState === 'Playing')
      this.timeWarpButtonEl.setAttribute('visible', true);
    this.addMana(++manaUnits);
  }),

  vrbuttonup: bindEvent(function(evt) {
    if (this.warpProcess.isAttached())
      return;
    this.timeWarpCounter = 0;
    this.warpProcess.start();
    this.gameStateEl.emit('startTimeWarp', { factor: TimeWarpFactor, duration: TimeWarpDuration });
    this.timeWarpButtonEl.setAttribute('button', 'pressedColor', 'white');
    this.removeMana(manaUnits--);
  }),

  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = this.curState = evt.detail;
    if (newState === 'Loading' || newState === 'MainMenu') {
      this.el.setAttribute('visible', false);
      this.warpProcess.stop();
    } else if (newState === 'LevelComplete') {
      this.warpProcess.stop();
      this.timeWarpButtonEl.setAttribute('visible', false);
    } else if (newState === 'NewGame') {
      score = 0;
      manaAvailUnits = 0;
      this.timeWarpButtonEl.setAttribute('visible', false);
      this.timeWarpButtonTextEl.setAttribute("text__start", "value", "ACTIVATE");
      manaUnits = ManaInitUnits;
      this.fillManabar();
      this.el.setAttribute('visible', true);
    } else if (newState === 'StartNextLevel') {
      this.el.setAttribute('visible', true);
      this.timeWarpButtonTextEl.setAttribute("text__start", "value", "ACTIVATE");
    } else if (newState === "Playing") {
      this.timeWarpButtonEl.setAttribute('visible', manaUnits > 0);
    }
  }),

  fillManabar() {
    this.manabarEl.childNodes.forEach((el, idx) => {
      el.setAttribute("color", idx < manaUnits ? ColorGreen : ColorGrey);
    });
  },
  addMana(nManaSeg) {
    const el = this.manabarEl.querySelector(`#Seg${nManaSeg}`);
    this.overlayPosition = Object.assign({}, el.getAttribute('position'));
    this.overlayPosition.z = 0.003;
    this.overlayWidth = ManaUnitWidth;
    this.manabarOverlayEl.setAttribute('position', this.overlayPosition);
    this.manabarOverlayEl.setAttribute('width', ManaUnitWidth);
    this.manabarOverlayEl.setAttribute('color', ColorYellow);
    this.manabarOverlayEl.setAttribute('visible', true);
    el.setAttribute('color', ColorGreen);
    this.manaAddProcess.start();
  },
  removeMana(nManaSeg) {
    const el = this.manabarEl.querySelector(`#Seg${nManaSeg}`);
    this.overlayPosition = Object.assign({}, el.getAttribute('position'));
    this.overlayPosition.z = 0.003;
    this.overlayWidth = ManaUnitWidth;
    this.manabarOverlayEl.setAttribute('position', this.overlayPosition);
    this.manabarOverlayEl.setAttribute('width', ManaUnitWidth);
    this.manabarOverlayEl.setAttribute('color', ColorYellow);
    this.manabarOverlayEl.setAttribute('visible', true);
    el.setAttribute('color', ColorGrey);
    this.manaRemoveProcess.start();
  }
});

export default {
  get mana() {
    return {
      manaUnitWidth: ManaUnitWidth,
      manaMaxUnits: ManaMaxUnits,
      manaUnits: manaUnits
    }
  }
}
